module.exports = __webpack_public_path__ + "static/media/feature-private1.a5cd3f8b.png";